// Reusable room constants and boundaries

export interface Collider {
  x: number;
  y: number;
  w: number;
  h: number;
}

// Standard room boundaries (960x540 stage)
export const STANDARD_BOUNDARIES: Collider[] = [
  { x: 0, y: 0, w: 960, h: 20 }, // top
  { x: 0, y: 520, w: 960, h: 20 }, // bottom
  { x: 0, y: 0, w: 20, h: 540 }, // left
  { x: 940, y: 0, w: 20, h: 540 }, // right
];

// Room dimensions
export const ROOM_WIDTH = 960;
export const ROOM_HEIGHT = 540;

// Common spawn points
export const COMMON_SPAWNS = {
  CENTER: { x: 480, y: 270 },
  BOTTOM_CENTER: { x: 480, y: 400 },
  LEFT_ENTRANCE: { x: 100, y: 400 },
  RIGHT_ENTRANCE: { x: 800, y: 400 },
  TOP_CENTER: { x: 480, y: 100 },
} as const;
